import { collectModules, type ModuleManifest } from './modules';

// Resolved at build time. Every src/modules/<name>/index.tsx that exists is
// bundled; with no module folders (every child) this is empty. Kept apart from
// modules.ts so its tests do not import real modules.
export const { moduleRoutes, standaloneModuleRoutes, moduleNavItems, moduleQaIds } = collectModules(
  import.meta.glob<{ default: ModuleManifest }>('../modules/*/index.tsx', { eager: true }),
);
